import React from 'react';
import { MessageCircle } from 'lucide-react';
import { heroData } from '../data/mock';

const Hero = () => {
  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${heroData.whatsappNumber}`, '_blank');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroData.backgroundImage}
          alt="Ochoa Herrera & Asociados"
          className="w-full h-full object-cover brightness-50"
          loading="eager"
          fetchpriority="high"
        />
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center">
        <h1 
          className="hero-large md:text-6xl lg:text-7xl mb-6 animate-fade-in font-bold drop-shadow-2xl"
          style={{ color: '#FFFFFF' }}
        >
          {heroData.headline}
        </h1>
        <p 
          className="body-large md:text-xl mb-10 max-w-2xl mx-auto leading-relaxed font-medium drop-shadow-xl"
          style={{ color: '#FFFFFF' }}
        >
          {heroData.subtitle}
        </p>
        <button
          onClick={handleWhatsAppClick}
          className="btn-primary-burgundy inline-flex items-center gap-3 px-8 py-4 bg-transparent border-2 border-white text-white hover:bg-white hover:text-[rgb(var(--burgundy-primary))] transition-smooth button-text rounded-none shadow-lg hover:shadow-xl"
        >
          <MessageCircle className="w-5 h-5" />
          {heroData.ctaText}
        </button>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-white/70 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
